import React from 'react';
import { TemplateFormItemsDisplayProps } from '../factory';

const TemplateFormItemsDisplay: React.FC<TemplateFormItemsDisplayProps> = () => {
  return null;
};

export default TemplateFormItemsDisplay;
